// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1a342","buttons":"PendingPaymentAlert_buttons__xw2AS"};